/* eslint-disable jsx-a11y/anchor-is-valid */

import React, { useState } from "react";
import { Link } from "react-router-dom";

import { useFormik } from "formik";
import * as Yup from "yup";
import clsx from "clsx";

import * as auth from "../redux/AuthRedux";
import { useDispatch } from "react-redux";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { toAbsoluteUrl } from "../../../../_jutemplate/helpers/AssetHelpers";
import "./auth.css";
import { login } from "../redux/AuthCRUD";


//image
import logo from "../../../../../src/assets/images/brandLogo/logo.png";

const initialValues = {
  phone: "",
  password: "",
};

const loginSchema = Yup.object().shape({
  phone: Yup.string().required("Phone number is required"),
  password: Yup.string()
    .min(3, "Password should be minimum 3 character")
    .max(50, " Password should be maximum 20 character")
    .required("Password is required"),
});

export function Login() {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      setLoading(true);
      setTimeout(() => {
        login(values.phone, values.password)
          .then(
            (res) => {
              setLoading(false);
              //let roleID = res?.data?.data?.role?.role_id

              if (res?.data?.data) {
                let token = res?.data?.data?.token;
                // console.log(token)
                // dispatch user
                dispatch(auth.actions.login(token));
              } else {
                // console.log('adadad')
                toast(res.data.message, {
                  theme: "dark",
                });
              }
              //setStatus(res.data.message)

              //0setSubmitting(false)
            },
            (err) => {
              setStatus(err.message);
              if (err.response.data.success === false) {
                toast.error(err.response.data.message, {
                  theme: "dark",
                });
                setStatus(err.response.data.message);
              } else {
                toast.error("Service Unavailable", {
                  theme: "dark",
                });
              }
              setSubmitting(false);
              setLoading(false);
            }
          )
          .catch(() => {
            setLoading(false);
            setSubmitting(false);
            setStatus("The login detail is incorrect");
          });
      }, 1000);
    },
  });

  return (
    <>
      {/* alert */}
      <ToastContainer />

      {/* form */}
      <form
        className="form w-100"
        onSubmit={formik.handleSubmit}
        noValidate
        id="kt_login_signin_form"
      >
        {/* begin :: Heading */}
        <div className="d-flex flex-column align-items-center mb-15">
       
          <img
            alt="Logo"
            src={toAbsoluteUrl(logo)}
            // className="h-45px"
            style={{height:'80px'}}
          />
        
          {/* <h5 className="text-center mt-5" style={{fontSize:'1.7rem' ,color:'#898D9D',fontWeight:'normal'}}>Welcome To VIRGINIA TECH</h5> */}
        </div>
        {/* begin::Heading */}

        {/* begin::Form group */}
        <div className="fv-row mb-10">
          <label className="form-label title fs-6 fw-bolder  required">Phone Number</label>
          <input
            placeholder="Phone Number"
            {...formik.getFieldProps("phone")}
            className={clsx(
              "form-control form-control-lg form-control-solid rounded-2 ",
              { "is-invalid": formik.touched.phone && formik.errors.phone },
              {
                "is-valid": formik.touched.phone && !formik.errors.phone,
              }
            )}
            type="text"
            name="phone"
            autoComplete="off"
          />
          {formik.touched.phone && formik.errors.phone && (
            <div className="fv-plugins-message-container">
              <span role="alert" className="error text-danger">
                {formik.errors.phone}
              </span>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Form group */}
        <div className="fv-row mb-15">
          <div className="d-flex justify-content-between mt-n5">
            <div className="d-flex flex-stack mb-2 w-100">
              <label className="form-label fw-bolder title required fs-6 mb-0">
                  Password
              </label>
            </div>
          </div>
          <input
            type="password"
            placeholder="Password"
            autoComplete="off"
            {...formik.getFieldProps("password")}
            className={clsx(
              "form-control form-control-lg form-control-solid rounded-2",
              {
                "is-invalid": formik.touched.password && formik.errors.password,
              },
              {
                "is-valid": formik.touched.password && !formik.errors.password,
              }
            )}
          />
          {formik.touched.password && formik.errors.password && (
            <div className="fv-plugins-message-container">
              <div className="fv-help-block">
                <span role="alert" className="error text-danger">
                  {formik.errors.password}
                </span>
              </div>
            </div>
          )}
        </div>
        {/* end::Form group */}

        {/* begin::Action */}
        <div className="d-flex justify-content-end align-items-center">
          {/* <a href="forgot-password" className='ps-5' style={{ color: "#9296A6" }}>
                  Forgot password?
            </a> */}
          <button
            type="submit"
            id="kt_sign_in_submit"
            className="btn w-100 rounded-3"
            style={{background:'#fe761c'}}
            // disabled={formik.isSubmitting || !formik.isValid}
            disabled={loading ? true : false}
          >
            {!loading && <span className="indicator-label fs-2 text-white">Login</span>}
            {loading && (
              <span className="indicator-progress fs-2" style={{ display: "block" }}>
                Please wait...
                <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
              </span>
            )}
          </button>
        </div>
        {/* end::Action */}
      </form>
    </>
  );
}
